import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import CustomCursor from "./Animations/Cursor";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Components/Home";
import About from "./Components/About";
import Projects from "./Components/Projects";
import Contact from "./Components/Contact";
import Profile from "./Components/Profile";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import Imprint from "./Components/Imprint";
// Onepager-Komponente
function OnePager() {
  return (
    <>
      <Helmet>
        <title>Viola Prinz – Creative Web Developer</title>
        <meta
          name="description"
          content="Hi, I'm Viola, a creative web developer with an artistic background."
        />
        <meta
          property="og:title"
          content="Viola Prinz – Creative Web Developer"
        />
        <meta
          property="og:description"
          content="Portfolio and projects by Viola Prinz"
        />
        <meta property="og:url" content="https://www.viola-prinz.com/" />
        <meta property="og:type" content="website" />
      </Helmet>

      <Home />
      <About />
      <Profile />
      <Projects />
      <Contact />
    </>
  );
}

// ScrollToHash Komponente
function ScrollToHash() {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const id = location.hash.replace("#", "");
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return null;
}

export default function App() {
  return (
    <div className="site-wrapper">
      <CustomCursor />
      <Header />

      {/* Diese Komponente sorgt für das automatische Scrollen */}
      <ScrollToHash />

      <main>
        <Routes>
          <Route path="/" element={<OnePager />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/imprint" element={<Imprint />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
